import { render, staticRenderFns } from "./PowerBi.vue?vue&type=template&id=21f8248e&scoped=true&lang=html&"
import script from "./PowerBi.vue?vue&type=script&lang=js&"
export * from "./PowerBi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f8248e",
  null
  
)

export default component.exports